import { render, staticRenderFns } from "./ContasDeUsuario.vue?vue&type=template&id=9c551bdc&"
import script from "./ContasDeUsuario.vue?vue&type=script&lang=js&"
export * from "./ContasDeUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports